(function(){
    'use strict'

    angular
    .module('app.reportes')
    .controller('ReporteVacaciones', ReporteVacaciones);

    ReporteVacaciones.$inject = ['$scope', '$animationsSrv', 'TiposPlanillaService', 'logger', 'UserInfoService', 'moment', 'ReportesService', 'EmpleadosService'];

    function ReporteVacaciones($scope, $animationsSrv, TiposPlanillaService, logger, UserInfoService, moment, ReportesService, EmpleadosService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.tiposPlanilla = [];

        vm.filterData = [];
        vm.empleados = [];

        vm.vacaciones = {
            companiaId: UserInfoService.getCompaniaId(),
            tipoPlanillaId: -1,
            empleadoId: '',
            empleadoNombre: ''
        };

        vm.busquedaEmpleado = {
            puestoId: -1,
            departamentoId: -1,
            tipoPlanillaId: -1,
            nombre: '',
            identificacion: '',
            companiaId: UserInfoService.getCompaniaId(),
            estado: -1
        };

        vm.title = 'Vacaciones';

        getTiposPlanilla();

        function getTiposPlanilla(){
            var promise = TiposPlanillaService.getAllForCalendarizacion(UserInfoService.getCompaniaId())
            .then(function(tiposPlanilla){
                tiposPlanilla.forEach(tipo => {
                    tipo.fechaInicio = moment(tipo.fechaInicio).toDate();
                    tipo.fechaFinal = moment(tipo.fechaFinal).toDate();
                });
                vm.tiposPlanilla = tiposPlanilla;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de planilla.');
            }); 
            
            return promise;
        };

        function doFormValidations(){
            //do nothing
        };

        vm.generar = function() {
            var promise = null;
                
            $scope.submitted = true;

            doFormValidations();

            if($scope.vacacionesForm.$valid){
                promise = ReportesService.getVacaciones(vm.vacaciones.tipoPlanillaId, vm.vacaciones.empleadoId, vm.vacaciones.periodoDesde, vm.vacaciones.periodoHasta);

                promise
                .then(function(response){
                    logger.success('Reporte Generado con éxito.');
                })
                .catch(function(error){
                    switch (error.status) {
                        case 500:
                            logger.error(`Hubo un error al generar el reporte: ${error.data.Message}`);
                            break;
                        case 401:
                            logger.error('La sessión ha terminado.');
                            break;
                        default:
                            logger.error('Hubo un error al generar el reporte');
                            break;
                    }
                }); 
            }
        };
        
        vm.limpiar = function(){
            $scope.submitted = false;
            // Reset the form model.
            vm.vacaciones = {
                tipoPlanillaId: -1,
            };
            
            // Set back to pristine.
            $scope.vacacionesForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.vacacionesForm.$setUntouched();
        }

        vm.openModalEmpleados = function(){
            if(vm.empleados.length > 0){
                $('#myModalEmpleados').modal('toggle');   
            }
            else{
                var promise = EmpleadosService.getAll(vm.busquedaEmpleado);

                promise
                .then(function(result){
                    vm.empleados = result.data;
                    $('#myModalEmpleados').modal('toggle'); 
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sessión ha terminado.');
                            break;
                    
                        default:
                            logger.error('Error al obtener los empleados.');
                            break;
                    }
                });
            }
             
        };

        vm.filterEmpleados = function(){
            vm.filterData = vm.empleados.filter(function(g) {
                return (g.id.toString().indexOf(vm.busquedaEmpleado.id) >= 0 || !vm.busquedaEmpleado.id) && 
                (g.nombre.toLowerCase().indexOf(vm.busquedaEmpleado.nombre.toLowerCase()) >= 0 || !vm.busquedaEmpleado.nombre);
            }).slice(0, 100);
        };

        vm.seleccionarEmpleado = function(e){
            vm.vacaciones.empleadoId = e.id;
            vm.vacaciones.empleadoNombre = e.nombre;
            $('#myModalEmpleados').modal('toggle');   
        };

    }
})();